module.exports = new __parcel__URL__("iveri.8a135c38.jpg").toString();